const buildQueryOptions = (data, headers) => {
  if (data) {
    return {
      method: 'POST',
      headers,
      body: JSON.stringify(data)
    };
  }
  return {
    method: 'GET',
    headers
  };
};

const inspectionCopyRequest = async (
  blazeId,
  blazeAuthToken,
  data,
  setRequestResponse,
  exceededPrintLimitMessage
) => {
  const baseUrl = new URL(process.env.BLAZE_WSB_API_BASE_URL);
  if (!baseUrl) return;
  const headers = {
    'Content-Type': 'application/json',
    'X-csrf-token': process.env.BLAZE_SECURE_HEADER || ''
  };

  const { username, password } = baseUrl;

  if (username && password) {
    baseUrl.username = '';
    baseUrl.password = '';
    headers.Authorization = `Basic ${btoa(`${username}:${password}`)}`;
  }
  headers['Api-Authorization'] = `Bearer ${blazeAuthToken}`;

  const baseUrlString = baseUrl.toString();
  const endpoint = `${baseUrlString}inspection/${blazeId}/${data ? 'request' : 'product'}`;

  const queryOptions = buildQueryOptions(data, headers);

  return fetch(endpoint, queryOptions)
    .then(response => response.json())
    .then(res => {
      const { error_message: errMessage, messages, status } = res;

      if (!setRequestResponse) return res;

      if (errMessage || messages) {
        const errorMessage = messages.validation ? messages.validation : errMessage;
        setRequestResponse({ loading: false, message: errorMessage, type: 'error' });

        if (messages.normal && messages.normal.length) {
          let [normalMessage] = messages.normal;
          if (normalMessage.includes('limit')) {
            normalMessage = exceededPrintLimitMessage;
          }

          setRequestResponse({ loading: false, type: status, message: messages.normal[0] });
        }
      } else {
        setRequestResponse({ loading: false, type: 'success' });
      }
    })
    .catch(e => setRequestResponse && setRequestResponse({ loading: false, message: e.message }));
};

const getIcMessage = (inspectionCopyData, messages, blazeAuthToken) => {
  const { restricedLoggedOutMessage, restricedLoggedInMessage, alreadyRequestedMessage } = messages;
  const {
    is_academic_approved: isAcademicApproved,
    is_ic_requested: isIcRequsted
  } = inspectionCopyData;
  if (isIcRequsted) return { showForm: false, message: alreadyRequestedMessage };
  if (!blazeAuthToken) return { showForm: false, message: restricedLoggedOutMessage };
  if (!isAcademicApproved) return { showForm: false, message: restricedLoggedInMessage };

  return { showForm: true, message: null };
};

const isFormValid = formData => {
  const {
    module_names: moduleNames,
    module_code: moduleCode,
    nb_students: nbStudents,
    module_start_date: startDate,
    inspection_copy_type: icType,
    module_consist_of: consistsOf,
    academic_level: academicLevel,
    bookshop_tagid: bookshopId
  } = formData;
  return (
    !!moduleNames &&
    !!moduleCode &&
    !!nbStudents &&
    !!startDate &&
    !!icType &&
    !!consistsOf &&
    !!academicLevel &&
    !!bookshopId
  );
};

export { inspectionCopyRequest, getIcMessage, isFormValid };
